// useCommMsg.js
// Axios 기반: 서버에서 메시지 목록을 가져와 상태에 저장하는 커스텀 훅

import { useEffect, useCallback } from "react";
import { useApiUtil } from "../utils/apiUtil";

const useCommMsg = (setCommMsg) => {
  const { gfnCallApi } = useApiUtil();

  // API 호출 함수 안정화
  const fetchCommMsg = useCallback(async () => {
    try {
      const result = await gfnCallApi({
        url: "common/msgList",
        method: "POST",
        data: {},
        showMsg: false,
      });
      const data = result?.data;
      if (Array.isArray(data) && data.length > 0) {
        setCommMsg(data);
      }
    } catch (error) {
      console.error("공통 메세지 로딩 실패:", error);
    }
  }, [gfnCallApi, setCommMsg]);

  // 최초 로딩 시 실행
  useEffect(() => {
    fetchCommMsg();
  }, []);
};

export default useCommMsg;
